import React, { useState } from "react";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import css from "./TodoFilter.module.css";
import { Input } from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import {
  CancelIconBlack,
  BookmarkIconBlack,
} from "../../../../../constant/imagePath";
import Colors from "../../../../../stories/assets/Colors";
import { ReactSVG } from "react-svg";
import ModalSkeletonCssClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import { SaveFilterComponent } from "../../../../../stories/SaveFilterComponent/SaveFilterComponent";
import MonthSmallCalander from "../../../../../components/MonthSmallCalander";
import { DoubleCalander } from "../../../../../stories/DoubleCalander/DoubleCalander";

const TodoFilterModal = ({
  show,
  setShow,
  tabState,
  location,
  setLocation,
  setStatus,
  status,
  date,
  setDate,
}) => {
  const [isSavedFilter, setIsSavedFilter] = useState(false);
  const [filterData, setFilterData] = useState([
    {
      id: 1,
      requestType: ["Royal Tennis Court"],
      startDate: "25 Aug 2021",
      endDate: "9 Sep 2021",
    },
    {
      id: 2,
      requestType: ["Royal Tennis Court", "Green Tennis Court"],
      startDate: "25 Aug 2021",
    },
    {
      id: 3,
      requestType: ["Royal Tennis Court", "Green Tennis Court"],
      startDate: "25 Aug 2021",
    },
    {
      id: 4,
      requestType: ["Royal Tennis Court"],
      startDate: "25 Aug 2021",
      endDate: "9 Sep 2021",
    },
  ]);

  const handleDelete = (index) => {
    const newArr = filterData.filter((item, i) => i !== index);
    setFilterData(newArr);
  };
  return (
    <>
      <style>{`
      .${ModalSkeletonCssClasses.body} {
        padding: 0px;
      }
          .modal .modal-dialog {
            width: 100% !important;
            margin: 0px !important;
          }
          .modal .modal-dialog {
            max-width: 100% !important;
            height: 100%;
        }
        .modal-content{
            min-height:100%
        }
        .modal { 
            border-radius: 0px;
            background: white;
          }
          @media screen and (max-width:425px){
          .MuiDateRangePickerDay-day{
               font-size:12px !important;
               line-height:14px !important;
          }
          .mehru span.MuiTypography-caption:before{
             font-size:14px !important;
               line-height:16px !important;

          }
        }
    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        borderRadius={"0px"}
        width={"100%"}
      >
        <Row className={`g-0`}>
          {!isSavedFilter ? (
            <>
              <Col sm={12} md={12}>
                <div
                  style={{
                    borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  }}
                  className={[css.FilterHeader].join(" ")}
                >
                  <ReactSVG
                    src={CancelIconBlack}
                    onClick={() => setShow(false)}
                  />

                  <h6
                    style={{
                      ...Fonts.b3,
                      color: Colors.neutralShadesOfNero,
                    }}
                  >
                    Filters
                  </h6>
                  <ReactSVG
                    src={BookmarkIconBlack}
                    onClick={() => setIsSavedFilter(true)}
                  />
                </div>
              </Col>
              <Col sm={12} md={12} className={css.scrollAbleDiv}>
                <div
                  className={[css.pb24].join(" ")}
                  style={{
                    borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  }}
                >
                  <div className={[css.DropDownDiv].join(" ")}>
                    <DropDown
                      label={"Choose location"}
                      placeholder={"All"}
                      options={[
                        {
                          value: "All",
                          label: "All",
                        },
                        {
                          value: "Royal-Tennis-Court",
                          label: "Royal Tennis Court",
                        },
                        {
                          value: "Green-Tennis-Court",
                          label: "Green Tennis Court",
                        },
                      ]}
                      setter={setLocation}
                      state={location}
                    />
                  </div>
                  {tabState && (
                    <div className={[css.DropDownDiv, css.mt32].join(" ")}>
                      <DropDown
                        label={"Status"}
                        placeholder={"All"}
                        options={[
                          {
                            value: "All",
                            label: "All",
                          },
                          {
                            value: "Evaluated",
                            label: "Evaluated",
                          },
                          {
                            value: "Not evaluated",
                            label: "Not evaluated",
                          },
                        ]}
                        setter={setStatus}
                        state={status}
                      />
                    </div>
                  )}
                </div>

                <div className={[css.calenderDiv].join(" ")}>
                  {/* Calender will be displayed here */}
                  {/* <p>Single Calender will be displayed here</p> */}
                  <DoubleCalander value={date} setValue={setDate} />
                  {/* <MonthSmallCalander value={date} setValue={setDate} /> */}
                </div>

                <div
                  style={{
                    borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  }}
                  className={[css.footerBtnsDiv].join(" ")}
                >
                  <LinkButtonWithIcon
                    text={"Clear All"}
                    textColor={Colors.neutralShadesOfNero}
                    customStyle={{
                      ...Fonts.b1Mobile,
                    }}
                  />

                  <Button
                    label={"Apply"}
                    customStyle={{
                      ...Fonts.b1Mobile,
                      padding: "12px 32px",
                      border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                      width: "156px",
                    }}
                    primary={true}
                    size="Large"
                  />
                </div>
              </Col>
            </>
          ) : (
            <>
              <Col sm={12}>
                <div
                  style={{
                    borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  }}
                  className={[css.FilterHeader].join(" ")}
                >
                  <ReactSVG
                    src={CancelIconBlack}
                    onClick={() => setIsSavedFilter(false)}
                  />

                  <h6
                    style={{
                      ...Fonts.b3,
                      color: Colors.neutralShadesOfNero,
                    }}
                  >
                    Saved Filters
                  </h6>
                  <div />
                </div>
              </Col>
              <Col sm={12} className={css.scrollAbleDiv}>
                {filterData.map((item, index) => {
                  return (
                    <SaveFilterComponent
                      title={item.requestType}
                      startDate={item.startDate}
                      endDate={item.endDate}
                      onClick={() => handleDelete(index)}
                    />
                  );
                })}
              </Col>
              <div
                style={{ backgroundColor: Colors.white }}
                className={[css.saveFilterBtnDiv].join(" ")}
              >
                <Button
                  label={"Save new Filter"}
                  customStyle={{
                    ...Fonts.b1,
                    padding: "12px 32px",
                    border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                    width: "100%",
                  }}
                  size="Large"
                />
              </div>
            </>
          )}
        </Row>
      </ModalSkeleton>
    </>
  );
};
export default TodoFilterModal;
